import { Injectable } from '@angular/core';
import { CreateCommandHandler } from '../../../core/service/command/create-command-handler.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';
import { advertismentCommand } from '../../model/const/command';
import { SendToPlatformParkingCommandHandler } from './send-to-platform-parking-command-handler.service';

@Injectable()
export class LettingAdvertismentParkingFormCommandHandlerResolver extends FormCommandHandlerResolver {
  constructor(
    createHandler: CreateCommandHandler,
    deleteHandler: DeleteFormCommandHandler,
    sendHandler: SendToPlatformParkingCommandHandler
  ) {
    super(createHandler, deleteHandler);
    this.addHandler(advertismentCommand.sendToPlatform, sendHandler);
  }
}
